// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3160": "ade2be4800a4","3556": "ee52632dd16b","494": "4077578422d4","5981": "9200fc8d30ac",}[chunkId] + ".css"
}